var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#a805fb",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499.59-507.74q21.1-23.54 29.35-52.44 8.24-28.9 8.24-61.77 0-32.87-8.24-61.51-8.25-28.64-29.35-52.18 50.41-3.8 85.54 28.77 35.13 32.56 35.13 85.18 0 52.61-35.13 84.92t-85.54 29.03Zm198.87 292.36v-59.59q0-34.49-13.69-64.26-13.69-29.77-48.1-48.87 78.74 13.74 118.52 41.37 39.79 27.63 39.79 71.76v59.59h-96.52Zm73.85-247.54v-86.16h-86.16v-33.84h86.16v-86.16h33.84v86.16h86.16v33.84h-86.16v86.16h-33.84Zm-426.16-41.85q-49.75 0-83.21-33.71-33.45-33.71-33.45-83.47t33.45-83.21q33.46-33.46 83.21-33.46 49.76 0 83.47 33.46 33.71 33.45 33.71 83.21 0 49.76-33.71 83.47t-83.47 33.71ZM67.69-215.38v-60.52q0-24.92 14.58-46.5 14.58-21.57 39.78-33.34 59.69-26.8 114.21-40.14 54.51-13.35 109.89-13.35 55.39 0 109.57 13.35 54.18 13.34 114.38 40.14 24.69 11.77 39.61 33.34 14.91 21.58 14.91 46.5v60.52H67.69Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersActive);
export default __webpack_public_path__ + "static/media/Users-active.b5450f617bb51768.svg";
export { ForwardRef as ReactComponent };